import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface ConfirmPersonalInfoStore {
  /**
   * Set once the user has confirmed or postponed the prompt, so it is asked at most
   * once per user and browser session even though the backend keeps reporting it as due.
   */
  handledUserId: number | null;
  markPromptHandled: (userId: number) => void;
}

const useConfirmPersonalInfoStore = create<ConfirmPersonalInfoStore>()(
  persist(
    (set) => ({
      handledUserId: null,
      markPromptHandled: (userId) => set({ handledUserId: userId })
    }),
    {
      name: 'confirmPersonalInfoStore',
      storage: createJSONStorage(() => sessionStorage)
    }
  )
);

// Getters
export const useIsPersonalInfoPromptHandled = (userId: number | undefined) =>
  useConfirmPersonalInfoStore((state) => userId !== undefined && state.handledUserId === userId);

// Actions
export const useConfirmPersonalInfoActions = () => {
  const markPromptHandled = useConfirmPersonalInfoStore((state) => state.markPromptHandled);
  return { markPromptHandled };
};
